import { Vault } from '@/features/vaults/types';

export const TheoriqStakingPoolVaultId = 'theoriq-staking-pool';

export const TheoriqStakingPoolVault: Vault = {
  id: TheoriqStakingPoolVaultId,
  type: 'multi-vault',
  name: 'Theoriq Staking Pool',
  description:
    'The Theoriq StakingPool lets users stake THQ to earn rewards and support network security. Stakers receive sTHQ, a yield-bearing token representing their share of the pool.sTHQ earns THQ emissions, so over time each sTHQ represents and can be redeemed for more THQ, hence the sTHQ/THQ exchange rate increases.',
  category: 'restaking',
  address: '0xbe515939fBA844A7063f119225012B072cE40D0c',
  compatibility: 'ERC4626',
  interop: {
    type: 'layer-zero',
    sourceCore: '0xbe515939fBA844A7063f119225012B072cE40D0c',
    targetCore: '0xA2598154978aBE38f017617972ED989283975fDD',
    targetNetwork: 'ethereum',
    targetAddress: '0x10d2DAb00E1d3F015C9be79F60947BC1BD413e36',
    sourceWithdrawalQueue: '0x0b89bC6259F906238Bb4E101E79c5480a2102e75',
  },
  curators: ['theoriq'],
  operator: [],
  points: [
    { entity: 'mellow', startTimestamp: 1738573595 },
    { entity: 'symbiotic', startTimestamp: 1738573595 },
  ],
  layer: 'Symbiotic',
  network: 'base',
  depositTokens: [
    {
      address: '0x0b2558bdBC7FFEC0f327fB3579c23daBD1699706',
      decimals: 18,
      symbol: 'THQ',
    },
  ],
  baseToken: '0x0b2558bdBC7FFEC0f327fB3579c23daBD1699706',
  lpTokenSymbol: 'sTHQ',
  lpTokenDecimals: 18,
  withdrawDuration: 1296000,
  withdrawDurationDisplay: '15 days',
  tokenRewards: [
    {
      token: {
        network: 'base',
        symbol: 'THQ',
        address: '0x0b2558bdBC7FFEC0f327fB3579c23daBD1699706',
        decimals: 18,
      },
      startTimestamp: 1745445600,
      startClaimTimestamp: 1745964000,
    },
  ],
  allocations: {
    showAllocationsTab: true,
  },
};
